import { GridFilterOperator } from '@mui/x-data-grid-pro';

import { NPIAutoComplete } from 'src/components/FormikComponents';

import { NPIDataGridColDef } from './NPIDataGrid';

/**
 * createColumnDef is a helper function that creates a column definition for the NPIDataGrid component.
 * The default values are:
 * - field: ''
 * - headerName: ''
 * - flex: 1
 * - minWidth: 200
 * - sortable: true
 * - filterable: true
 * @param colDefs
 * @returns a column definition object with default values.
 */
export function createColumnDef(colDefs: NPIDataGridColDef): NPIDataGridColDef {
    const defaultColDefs: NPIDataGridColDef = {
        field: '',
        headerName: '',
        flex: 1,
        minWidth: 150,
        sortable: true,
        filterable: true,
        renderCell: ({ value }) => {
            return (
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        width: '100%',
                        height: '100%',
                    }}
                >
                    {value}
                </div>
            );
        },
    };

    if (colDefs.field === 'actions') {
        return { ...defaultColDefs, ...colDefs, sortable: false, filterable: false };
    }

    return { ...defaultColDefs, ...colDefs };
}

export function getDefaultFilterOperators({
    value,
    label,
    accessor,
    name,
    filterOptions,
}): GridFilterOperator<unknown, unknown, unknown>[] {
    return [
        {
            label,
            value,
            getApplyFilterFn: (filterItem) => {
                return (value) => {
                    return value === filterItem.value?.value;
                };
            },
            InputComponent: NPIAutoComplete,
            InputComponentProps: {
                name,
                options: filterOptions[accessor],
                useFormik: false,
            },
            getValueAsString: (value) => {
                return value.value;
            },
        },
    ];
}
